export default {
  sm: `
    Abundant natural energy for eco-friendly operations
  `,
  lg: `
    Abundant natural energy
    for eco-friendly operations
  `,
};
